import React from 'react';
import { Box, Divider } from '@mui/material';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import CommonButton from '@src/new-components/Button';
import { ImportContactsRounded } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { ONBOARDING_POPUP_TYPE } from '@src/constants';
import { StyledHeader } from './index.style';

const Header = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getFeatureValue } = useFeatureFlags();
  const user = useSelector((state) => state.auth.user);

  const onboardingPopupEnabled = getFeatureValue(
    FEATURE_KEYS.ONBOARDING_POPUP,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  return (
    <StyledHeader>
      <div className="header-wrapper">
        <Box className="header-content">
          <Typography variant="heading-38-bold" color={COLOR.darkGray}>
            {t('voiceCloningHomeTitle')}
          </Typography>
          <Typography variant="body-14-regular" color={COLOR.label2[64]}>
            {t('voiceCloningHomeDescription')}
          </Typography>
        </Box>
        {onboardingPopupEnabled && (
          <CommonButton
            startIcon={
              <ImportContactsRounded
                sx={{ fontSize: '24px', color: COLOR.navyBlue }}
              />
            }
            variant="outlined"
            className="dialog-actions-button"
            sx={{
              border: `1px solid ${COLOR.secondary[16]}`,
              padding: '10px 16px',
              borderRadius: '8px',
            }}
            textProps={{
              variantText: 'body-14-semibold',
              color: COLOR.indigo.default,
            }}
            onClick={() => {
              dispatch(
                actions.onboardingPopup.showOnboardingPopup({
                  type: ONBOARDING_POPUP_TYPE.VOICE_CLONING,
                }),
              );
            }}
          >
            {t('onboardingViewGuideDetail')}
          </CommonButton>
        )}
      </div>
      <Divider className="divider" />
    </StyledHeader>
  );
};

export default Header;
